import { JobStatusProgressCellRendererProps } from '../../../types/frontend/cell-renderers/JobStatusCellRenderer.types';
import { JobStatus } from '../../../types/backend/jobStatus';
import { LinearProgress } from '@getgo/chameleon-web-react-wrapper/register';
import styles from './JobStatusProgressCellRenderer.module.scss';
import { ReactElement, useMemo } from 'react';
import { clsx } from 'clsx';

export function JobStatusProgressBar({
  jobRunStatistics,
  jobStatus
}: JobStatusProgressCellRendererProps): ReactElement {
  const successPercentage = useMemo(() => {
    return jobRunStatistics ? (jobRunStatistics.successfulUpdateCount / jobRunStatistics.totalUpdateCount) * 100 : 0;
  }, [jobRunStatistics]);

  const failPercentage = useMemo(() => {
    return jobRunStatistics ? (jobRunStatistics.failedUpdateCount / jobRunStatistics.totalUpdateCount) * 100 : 0;
  }, [jobRunStatistics]);

  if (jobStatus === JobStatus.Cancelled || jobStatus === JobStatus.None || jobStatus === JobStatus.Scheduled) {
    return <></>;
  }

  if (jobStatus === JobStatus.Running) {
    return <LinearProgress className={styles.linearProgress} />;
  }

  return (
    <>
      <div className={styles.successPart} style={{ width: `${successPercentage}%` }} />
      <div
        className={clsx(
          jobRunStatistics &&
            jobRunStatistics.successfulUpdateCount > 0 &&
            jobRunStatistics.failedUpdateCount > 0 &&
            styles.separator
        )}
      />
      <div className={styles.failedPart} style={{ width: `${failPercentage}%` }} />
    </>
  );
}
